import { useQuery } from '@tanstack/react-query';
import { api } from '../api';
import { can, type Me } from '../auth/me';
import { TASKS_KEY, TASKS_RESOURCE } from './types';

/**
 * Whether a user without a grant on the tasks has any task given to them, open or done (P7: the person responsible
 * always sees their tasks): then "Zadania" shows in the menu and the calendar offers the layer. Only a count
 * (`/api/me/company-tasks/count`), asked only for such users.
 */
export function useAssignedTasks(me: Me | null | undefined): boolean {
  return useAssignedTasksState(me).assigned;
}

/** `useAssignedTasks` and whether the count is still on its way (`loading`: the first tab of "Zadania" waits for it). */
export function useAssignedTasksState(me: Me | null | undefined): { assigned: boolean; loading: boolean } {
  const granted = !!me && can(me, TASKS_RESOURCE, 'view');
  const q = useQuery({
    queryKey: [...TASKS_KEY, 'assigned-count'],
    enabled: !!me && !granted,
    staleTime: 60_000,
    retry: false,
    queryFn: () => api<{ count: number }>('/api/me/company-tasks/count'),
  });
  return { assigned: !granted && (q.data?.count ?? 0) > 0, loading: !!me && !granted && q.isPending };
}
